// import IMAGES from "./image/index.js"

const IMAGES = {
    earthGirl1: require("./earth_girl/IMG_7058.JPG").default,
    earthGirl2: require("./earth_girl/IMG_7059.JPG").default,
    earthGirl3: require("./earth_girl/IMG_7061.JPG").default,
    factory1: require("./factory/IMG_7065.JPG").default,
    factory2: require("./factory/IMG_7070.JPG").default,
    leafTrash1: require("./leaf_trash/IMG_7073.JPG").default,
    leafTrash2: require("./leaf_trash/IMG_7075.JPG").default,
    recyleGirl1: require("./recycling_girl/IMG_7062.JPG").default,
    recyleGirl2: require("./recycling_girl/IMG_7063.JPG").default,
    lastHope1: require("./last_hope/IMG_7064.jpg").default,
    lastHope2: require("./last_hope/IMG_7071.jpg").default,
}

export default IMAGES;
